import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';

class ModalDatosIncorrectos extends Component {
    render() {
        return (
                <div className="modal fade-out" id="datosIncorrectos" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog">
                            <div className="modal-content modal-wide">
                                <div className="modal-header-new">
                                    <div className="closeNew" data-dismiss="modal" aria-hidden="true"><label className="ti-close clickable"></label></div>
                                    <h2 className="modal-title-new" id="myModalLabel">Datos de cliente incorrectos</h2>
                                </div>
                                <div className="modal-body-new">Debe rectificar los datos erróneos en el Sistema de Clientes de la Entidad para poder realizar el Alta de Cuenta de Tarjeta de Crédito.</div>
                                <div className="modal-footer-new"><GenericSimpleButton text="Aceptar" dataDismiss={"modal"} buttonClass="btn btn-cta float-right" /></div>
                        </div>
                    </div>
                </div>
        );
    }
};

export default ModalDatosIncorrectos